import { FormFieldRow } from '@/components/forms/BookTradeForm/FormFieldRow'
import { ValueDateField } from '@/components/forms/RunRiskCalibrationForm/fields/ValueDateField'

export interface DerivedMetricsFieldsProps {}

export const DerivedMetricsFields: React.FC<DerivedMetricsFieldsProps> = ({}) => {
  return (
    <FormFieldRow>
      <ValueDateField />
    </FormFieldRow>
  )
}
